import { createStore, reconcile } from 'solid-js/store';

export function useReducer<T extends object, A extends object>(
  reducer: (state: T, action: A) => T,
  state: T
): [T, (action: A) => void] {
  const [store, setStore] = createStore<T>(state);
  const dispatch = (action: A): void => {
    state = reducer(state, action);
    setStore(reconcile(state));
  };
  return [store, dispatch];
}
